/**
 * ColorboxDirective class for creating a custom AngularJS directive.
 * This directive is used to create a colorbox element that can display content in a modal-like fashion.
 */
export class ColorboxDirective {
    /**
     * Constructs a new instance of the ColorboxDirective.
     * @param {Object} $compile - AngularJS compile service.
     * @param {Object} $routeParams - AngularJS route parameters service.
     * @param {Object} TaskSelectionService - Service for handling task selections.
     */
    constructor($compile, $routeParams, TaskSelectionService) {
        this.$compile = $compile;
        this.$routeParams = $routeParams;
        this.TaskSelectionService = TaskSelectionService;
        this.logIdentifier = 'ColorboxDirective';
    }

    /**
     * Returns the directive definition object.
     * @returns {Object} The directive definition object.
     */
    getDirective() {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                options: '@',
                alt: '@',
                title: '@',
                width: '@',
                mediaURL: '@src',
                colorboxActive: '&',
                iframeObject: '='
            },
            templateUrl: '/views/ib/components/ColorboxDirective.html',
            link: (scope, element, attrs) => {
                // Check if the iframe attribute is defined
                scope.iframe = angular.isDefined(attrs.iframe);
                // SMELL: Hardcoded error message might not be user-friendly or localized.
                if (scope.iframe && !scope.iframeObject) { throw new Error("iframeObject is required."); }

                // Get the task UUID from the TaskSelectionService
                scope.taskUUID = this.TaskSelectionService.getTaskUUID();
                // Check if the colorbox plugin is loaded
                scope.colorboxLoaded = angular.isDefined(jQuery().colorbox);

                // Attach a click event handler to the parent element
                element.parent().on('click', () => {
                    if (scope.iframe || scope.colorboxActive()) {
                        var options = {
                            maxHeight: '80%',
                            open: true
                        };

                        if (scope.iframe) {
                            options.iframe = true;
                            options.height = '80%';
                            options.width = '80%';
                        }
                        // Extend the options object with the options provided in the scope
                        angular.extend(options, scope.$eval(scope.options));

                        // Apply the colorbox options to the element
                        element.find('.colorbox-link').colorbox(options);
                    }
                });
            }
        };
    }
}

/**
 * Registers the ColorboxDirective as an AngularJS directive.
 * @param {Object} module - The AngularJS module to which the directive will be registered.
 */
export function registerAsfColorboxDirective(module) {
    module.directive('asfColorbox', ['$compile', '$routeParams', 'TaskSelectionService', function($compile, $routeParams, TaskSelectionService) {
        const directive = new ColorboxDirective($compile, $routeParams, TaskSelectionService);
        return directive.getDirective();
    }]);
}